export default (theme) => ({
  onHoldMessageWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    height: 150,
    width: 'auto',
    objectFit: 'contain',
  },
  onHoldMessage: {
    overflow: 'hidden',
    padding: 40,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '75%',
    width: 'auto',
    height: 'auto',
    backgroundColor: theme.palette.background.white,
    fontSize: 22,
    '& h4': {
      fontWeight: 'bold',
      margin: '10px auto 5px',
    },
  },
  infoWrapper: {
    textAlign: 'center',
  },
  onHoldMobileMessage: {
    marginTop: 20,
    fontSize: 18,
    fontWeight: 'bold',
  },
});
